enum PowerSupplyUpdateAction {
  INSTALL = 'install'
}

export default PowerSupplyUpdateAction
